const normalizeHexColor = require('../normalizeHexColor');

/**
 * Normalizes color value from colors map and re-groups map
 * to make sure that #000 and #000000 will end up in one group.
 * @param {Object} colorsMap
 * @return {Object}
 */
const normalizeColorsMap = (colorsMap) =>
    Object.keys(colorsMap).reduce((acc, curr) => {
        const hex = normalizeHexColor(curr);
        acc[hex] = acc[hex]
            ? [ ...acc[hex], ...colorsMap[curr] ]
            : colorsMap[curr];
        return acc;
    }, {});

module.exports = normalizeColorsMap;
